import React from 'react';
import './CustomLoader.scss';

const Loader = () => {
  return (
    <div className="container">
    <section>
      <div className="loader loader-1">
        <div className="loader-outter"></div>
        <div className="loader-inner"></div>
      </div>
    </section>
  </div>
  );
};

export default Loader;
